import React from 'react';
import '../../../../public/style/login.scss';

/*img */
import Logo from '../../../../public/images/logo-gauss.png';
import LogoDesert from '../../../../public/images/logo-desertpoint.png';
import LoadingModal from '../common/loadingModal';
import { VersionPackage } from '../common/versionPackage';

const LoginForm = (props) => {
  /**
   * This method handles keyboard events
   */
  const handleKeyboardEvent = (event) => {
    const enterKeyCode = 13;

    // check if the pressed key is the Enter key (key code 13)
    if (event.keyCode === enterKeyCode) {
      props.handleLogin(event);
    }
  }

  return (
    <div className="container_login" onKeyDown={handleKeyboardEvent}>
      <div className="container_login_box">
        <div className="container_login_img">
          <img src={Logo} alt="Gauss control" />
        </div>
        <div className="container_login_form">
          <form onSubmit={props.handleLogin}>
            <h1>{props.language.login.main.login}</h1>
            <div className="box-form icon icon_user">
              <input
                type="text"
                className="login"
                id="user"
                placeholder={props.language.login.main.email}
                autoComplete="username"
                autoFocus
              />
            </div>
            <div className="box-form icon icon_pass top">
              <input
                type="password"
                className="login"
                id="password"
                placeholder={props.language.login.main.password}
                autoComplete="new-password"
              />
            </div>
            <div className="box-form top">
              {props.message && <p className="message">{props.language.login.main.error}</p>}
            </div>
            <div className="box-form top topx2 center">
              <input type="submit" className="login" value={props.language.login.main.loginButton} />
            </div>
          </form>
          {props.loading && (
            <LoadingModal language={props.language}/>
          )}
        </div>
        <div className="container_login_img__bottom">
          <p>{props.language.login.main.developedBy}</p>
          <img src={LogoDesert} alt="Desert point" />
        </div>  
      </div>
      <div className="container_login_version">
        {
          props.showVersion && (
            <VersionPackage />
          )
        }
      </div>
    </div>
  )
};

export default LoginForm;



// WEBPACK FOOTER //
// ./source/client/components/login/index.jsx